import type { LatLngTuple } from 'leaflet';
import { TRANSPORT_TYPE_CODE } from '@/constants/transportTypes';

const GOOGLE_MAPS_SEARCH_URL = 'https://www.google.com/maps/search/?api=1&query=';
const GOOGLE_MAPS_DIRECTIONS_URL = 'https://www.google.com/maps/dir/';
const GOOGLE_MAPS_API_VERSION = '1';

export type GoogleMapsTravelMode = 'driving' | 'walking';

const toCoordinateText = ([latitude, longitude]: LatLngTuple): string => `${latitude},${longitude}`;

export function getTravelModeForTransportCode(
  transportCode: string | null | undefined,
): GoogleMapsTravelMode {
  return transportCode === TRANSPORT_TYPE_CODE.WALK ? 'walking' : 'driving';
}

export function getGoogleMapsUrl(latitude: number, longitude: number): string {
  return `${GOOGLE_MAPS_SEARCH_URL}${latitude},${longitude}`;
}

export function getGoogleMapsDirectionsUrl(
  origin: LatLngTuple,
  destination: LatLngTuple,
  travelMode: GoogleMapsTravelMode,
): string {
  const params = new URLSearchParams({
    api: GOOGLE_MAPS_API_VERSION,
    origin: toCoordinateText(origin),
    destination: toCoordinateText(destination),
    travelmode: travelMode,
  });
  return `${GOOGLE_MAPS_DIRECTIONS_URL}?${params.toString()}`;
}
